import { render, staticRenderFns } from "./order_sent.vue?vue&type=template&id=71253308&scoped=true"
import script from "./order_sent.vue?vue&type=script&lang=js"
export * from "./order_sent.vue?vue&type=script&lang=js"
import style0 from "./order_sent.vue?vue&type=style&index=0&id=71253308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71253308",
  null
  
)

export default component.exports